// extracted by mini-css-extract-plugin
export default {"input":"Vekca8"};